export const GOVERNANCE_ACTION_STATUS_FILTERS = [
  {
    value: "live",
    label: "Live",
  },
  {
    value: "enacted",
    label: "Enacted",
  },
  {
    value: "ratified",
    label: "Ratified",
  },
  {
    value: "expired",
    label: "Expired",
  },
];
